import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-336550fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "insights-page",
  "aria-labelledby": "workout-insights-title"
}
const _hoisted_2 = { class: "insights-page__header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "insights-page__eyebrow" }, "Workouts"),
  /*#__PURE__*/_createElementVNode("h1", { id: "workout-insights-title" }, "Workout insights"),
  /*#__PURE__*/_createElementVNode("p", { class: "insights-page__intro" }, "Finished-workout trends, most performed workouts, and configured training time.")
], -1))
const _hoisted_4 = { class: "insights-page__refresh" }
const _hoisted_5 = {
  key: 0,
  role: "status"
}
const _hoisted_6 = {
  key: 0,
  class: "insights-page__loading",
  role: "status",
  "aria-live": "polite"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Loading workout insights…", -1))
const _hoisted_8 = {
  key: 1,
  class: "insights-page__error",
  role: "alert"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-exclamation-circle",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "Insights could not be loaded", -1))
const _hoisted_11 = {
  key: 2,
  class: "insights-page__content"
}
const _hoisted_12 = {
  class: "insights-metrics",
  "aria-label": "Workout summary"
}
const _hoisted_13 = { class: "insights-card metric-card" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "metric-card__icon metric-card__icon--green",
  "aria-hidden": "true"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-check-circle" })
], -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Finished workouts", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Saved after reaching the workout overview · selected weeks", -1))
const _hoisted_17 = {
  class: "insights-card trend-card",
  "aria-labelledby": "weekly-workouts-title"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "insights-page__eyebrow" }, "Completion", -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { id: "weekly-workouts-title" }, "Workouts done per week", -1))
const _hoisted_20 = { class: "trend-card__period" }
const _hoisted_21 = {
  class: "trend-card__navigation",
  "aria-label": "Weekly workout insights period"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "trend-card__definition" }, " A persisted standard workout is the current completion signal. Quickstart and group workouts are stored elsewhere and are not included. ", -1))
const _hoisted_23 = { class: "trend-card__chart-scroll" }
const _hoisted_24 = ["aria-label"]
const _hoisted_25 = { class: "trend-card__value" }
const _hoisted_26 = { class: "trend-card__bar-track" }
const _hoisted_27 = ["title"]
const _hoisted_28 = { class: "trend-card__label" }
const _hoisted_29 = {
  class: "ranking-grid",
  "aria-label": "Workout rankings"
}
const _hoisted_30 = {
  class: "insights-card ranking-card",
  "aria-labelledby": "top-completed-title"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "insights-page__eyebrow" }, "Most performed"),
  /*#__PURE__*/_createElementVNode("h2", { id: "top-completed-title" }, "Top 10 workouts done")
], -1))
const _hoisted_32 = {
  key: 0,
  class: "ranking-list"
}
const _hoisted_33 = { class: "ranking-list__position" }
const _hoisted_34 = ["title"]
const _hoisted_35 = { class: "ranking-list__count" }
const _hoisted_36 = {
  key: 1,
  class: "ranking-card__empty"
}
const _hoisted_37 = {
  class: "insights-card ranking-card",
  "aria-labelledby": "most-time-spent-title"
}
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("p", { class: "insights-page__eyebrow" }, "Configured exercise time"),
  /*#__PURE__*/_createElementVNode("h2", { id: "most-time-spent-title" }, "Most time spent workouts")
], -1))
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "trend-card__definition" }, "Exercise minutes only; countdown and break time are excluded.", -1))
const _hoisted_40 = {
  key: 0,
  class: "ranking-list"
}
const _hoisted_41 = { class: "ranking-list__position" }
const _hoisted_42 = ["title"]
const _hoisted_43 = { class: "ranking-list__count" }
const _hoisted_44 = {
  key: 1,
  class: "ranking-card__empty"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ProgressSpinner = _resolveComponent("ProgressSpinner")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Button, {
        label: "Back to workouts",
        icon: "pi pi-arrow-left",
        class: "p-button-outlined",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/workouts')))
      })
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        label: "Refresh",
        icon: "pi pi-refresh",
        disabled: _ctx.loading,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadInsights()))
      }, null, 8, ["disabled"]),
      (_ctx.loadedAt)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, "Retrieved at " + _toDisplayString(_ctx.loadedAt) + ". Refresh to fetch the latest figures.", 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createVNode(_component_ProgressSpinner, { "stroke-width": "3" }),
          _hoisted_7
        ]))
      : (_ctx.error)
        ? (_openBlock(), _createElementBlock("section", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", null, [
              _hoisted_10,
              _createElementVNode("p", null, _toDisplayString(_ctx.error), 1)
            ]),
            _createVNode(_component_Button, {
              label: "Try again",
              class: "p-button-outlined",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadInsights()))
            })
          ]))
        : (_ctx.insights)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("section", _hoisted_12, [
                _createElementVNode("article", _hoisted_13, [
                  _hoisted_14,
                  _createElementVNode("div", null, [
                    _hoisted_15,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.formatNumber(_ctx.insights.completedWorkoutsInPeriod)), 1),
                    _hoisted_16
                  ])
                ])
              ]),
              _createElementVNode("section", _hoisted_17, [
                _createElementVNode("header", null, [
                  _createElementVNode("div", null, [
                    _hoisted_18,
                    _hoisted_19,
                    _createElementVNode("p", _hoisted_20, _toDisplayString(_ctx.selectedPeriodLabel), 1)
                  ]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Button, {
                      label: "Older weeks",
                      icon: "pi pi-arrow-left",
                      class: "p-button-outlined p-button-sm",
                      disabled: _ctx.loading || !_ctx.insights.hasOlderWeeks,
                      onClick: _ctx.showOlderWeeks
                    }, null, 8, ["disabled", "onClick"]),
                    _createVNode(_component_Button, {
                      label: "Newer weeks",
                      icon: "pi pi-arrow-right",
                      "icon-pos": "right",
                      class: "p-button-outlined p-button-sm",
                      disabled: _ctx.loading || !_ctx.insights.hasNewerWeeks,
                      onClick: _ctx.showNewerWeeks
                    }, null, 8, ["disabled", "onClick"]),
                    _createElementVNode("span", null, "52 non-overlapping weeks · Monday start · " + _toDisplayString(_ctx.insights.reportingTimeZone), 1)
                  ])
                ]),
                _hoisted_22,
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", {
                    class: "trend-card__chart",
                    role: "img",
                    "aria-label": _ctx.weeklyTrendDescription,
                    style: _normalizeStyle({ '--week-count': _ctx.insights.weeklyCompletedWorkouts.length })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insights.weeklyCompletedWorkouts, (week) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: week.weekStart,
                        class: "trend-card__week"
                      }, [
                        _createElementVNode("span", _hoisted_25, _toDisplayString(week.completedWorkouts), 1),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("span", {
                            class: "trend-card__bar trend-card__bar--workouts",
                            style: _normalizeStyle({ height: `${_ctx.barHeight(week.completedWorkouts)}%` }),
                            title: `${_ctx.formatWeekLabel(week.weekStart)}: ${week.completedWorkouts} finished workouts`
                          }, null, 12, _hoisted_27)
                        ]),
                        _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.formatWeekLabel(week.weekStart)), 1)
                      ]))
                    }), 128))
                  ], 12, _hoisted_24)
                ])
              ]),
              _createElementVNode("section", _hoisted_29, [
                _createElementVNode("article", _hoisted_30, [
                  _createElementVNode("header", null, [
                    _hoisted_31,
                    _createElementVNode("span", null, _toDisplayString(_ctx.selectedPeriodLabel), 1)
                  ]),
                  (_ctx.insights.topCompletedWorkouts.length)
                    ? (_openBlock(), _createElementBlock("ol", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insights.topCompletedWorkouts, (workout, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: workout.key
                          }, [
                            _createElementVNode("span", _hoisted_33, _toDisplayString(index + 1), 1),
                            _createElementVNode("strong", {
                              title: workout.name
                            }, _toDisplayString(workout.name), 9, _hoisted_34),
                            _createElementVNode("span", _hoisted_35, _toDisplayString(_ctx.formatNumber(workout.count)), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_36, "No finished workouts in these weeks."))
                ]),
                _createElementVNode("article", _hoisted_37, [
                  _createElementVNode("header", null, [
                    _hoisted_38,
                    _createElementVNode("span", null, _toDisplayString(_ctx.selectedPeriodLabel), 1)
                  ]),
                  _hoisted_39,
                  (_ctx.insights.mostTimeSpentWorkouts.length)
                    ? (_openBlock(), _createElementBlock("ol", _hoisted_40, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.insights.mostTimeSpentWorkouts, (workout, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: workout.key
                          }, [
                            _createElementVNode("span", _hoisted_41, _toDisplayString(index + 1), 1),
                            _createElementVNode("strong", {
                              title: workout.name
                            }, _toDisplayString(workout.name), 9, _hoisted_42),
                            _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.formatMinutes(workout.totalMinutes)), 1)
                          ]))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("p", _hoisted_44, "No configured workout time in these weeks."))
                ])
              ])
            ]))
          : _createCommentVNode("", true)
  ]))
}